import { render, staticRenderFns } from "./JobOrderList.vue?vue&type=template&id=65ca4117&scoped=true&"
import script from "./JobOrderList.vue?vue&type=script&lang=js&"
export * from "./JobOrderList.vue?vue&type=script&lang=js&"
import style0 from "./JobOrderList.vue?vue&type=style&index=0&id=65ca4117&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ca4117",
  null
  
)

export default component.exports